export default __webpack_public_path__ + "static/media/Spiteful Gauntlets.80126a46.jpg";